import { HoaType, HoaTypeLabels } from './HoaType';
import { PropertyTaxSummaryType, PropertyTaxSummaryTypeLabels } from './PropertyTaxSummaryType';
import {
  MortgageSupportingDocumentsType,
  MortgageSupportingDocumentsTypeLabels,
} from './MortgageSupportingDocumentsType';
import {
  JudgementLienDocumentTypeLabels,
  eJudgementLienDocumentType,
} from '../../ui-toolkit/orders/interfaces/titleReport/eJudgementLienDocumentType';
import {
  eCurativeGradeType,
  ePrettyCurativeGradeType,
} from '../../ui-toolkit/orders/interfaces/titleReport/eCurativeGradeType';
import {
  DeedDocumentTypeLabels,
  eDeedDocumentType,
} from '../../ui-toolkit/orders/interfaces/titleReport/eDeedDocumentType';
import { eEstateType, prettyEstateTypeLabels } from '../../ui-toolkit/orders/interfaces/titleReport/eEstateType';
import {
  eMortgageDocumentType,
  MortgageDocumentLabels,
} from '../../ui-toolkit/orders/interfaces/titleReport/eMortgageDocumentType';

export { HoaType, HoaTypeLabels } from './HoaType';
export { PropertyTaxSummaryType, PropertyTaxSummaryTypeLabels } from './PropertyTaxSummaryType';

export interface IOption {
  label: string;
  value: string;
  ordered?: string;
}

export type IOptions = IOption[];

export const getOptions = (values: {}, labels: {}): IOptions =>
  Object.values(values).map((value: any) => ({ value, label: labels[value] }));

export const judgementLienDocumentOptions = getOptions(eJudgementLienDocumentType, JudgementLienDocumentTypeLabels);

export const curativeGradeOptions = getOptions(eCurativeGradeType, ePrettyCurativeGradeType);

export const deedDocumentOptions = getOptions(eDeedDocumentType, DeedDocumentTypeLabels);

export const estateOptions = getOptions(eEstateType, prettyEstateTypeLabels);

export const hoaOptions = getOptions(HoaType, HoaTypeLabels);

export const mortgageDocumentOptions = getOptions(eMortgageDocumentType, MortgageDocumentLabels);

export const mortgageSupportDocumentOptions = getOptions(
  MortgageSupportingDocumentsType,
  MortgageSupportingDocumentsTypeLabels
);

export const propertyTaxSummaryOptions = getOptions(PropertyTaxSummaryType, PropertyTaxSummaryTypeLabels);
